<template>
  <div>
    <dashboard-indicadores>
      <template #dashboard-title>{{ title }}</template>
      <template #content-top>
        <div class="dashboard-header__wrapper">
          <div class="dashboard-header__buttons-wrapper">
            <dashboard-action-button
              class="mr-2 mr-lg-3"
              expandable
              :active="isCoordenadoriasDatasetActive">
              Coordenadorias&nbsp;
              <span v-if="isCoordenadoriasDatasetActive && activeDataset.length">
                ({{ activeDataset.length }})
              </span>
              <template #expandable-content="{ hideExpandableContent }">
                <div class="form-datasets-filter__wrapper">
                  <form-datasets-filter
                    :options="datasetCoordenadoriasEstado"
                    :active-dataset-options="getCoordenadoriasActiveDataset"
                    @confirm="(data) => formConfirm('c', data, hideExpandableContent)"
                    @cancel="() => hideExpandableContent()" />
                </div>
              </template>
            </dashboard-action-button>
            <dashboard-action-button
              expandable
              :active="isMunicipioDatasetActive">
              Municípios&nbsp;
              <span v-if="isMunicipioDatasetActive && activeDataset.length">
                ({{ activeDataset.length }})
              </span>
              <template #expandable-content="{ hideExpandableContent }">
                <div class="form-datasets-filter__wrapper">
                  <form-datasets-filter
                    :options="datasetMunicipiosEstado"
                    :active-dataset-options="getMunicipiosActiveDataset"
                    @confirm="(data) => formConfirm('m', data, hideExpandableContent)"
                    @cancel="() => hideExpandableContent()" />
                </div>
              </template>
            </dashboard-action-button>
          </div>
          <div class="dashboard-header__chips-wrapper">
            <dashboard-datasets-chips
              :datasets="activeDataset"
              :dataset-geral="activeDatasetGeral"
              :chip-data-coloring-rule="riskColoringRule"
              @remove-dataset-item="removeDatasetItem" />
          </div>
        </div>
      </template>
      <template #content-middle>
        <div class="chart-wrapper">
          <line-chart-dados-coleta
            :datasets="chartDatasets"
            :tooltip-coloring-callback="riskColoringRule"
            :scale-x-text="scaleXText"
            :scale-y-text="scaleYText" />
        </div>
      </template>
      <template #content-bottom>
        <div class="action-plans">
          <p class="action-plans__title">Plano de ação</p>
          <dashboard-action-plan
            v-for="(riskLevel, index) in Object.keys(riskLevels)"
            :key="index"
            :box-title="riskLevels[riskLevel].riskTitle"
            :box-featured-text="riskLevels[riskLevel].riskDataValue"
            :box-link="riskLevels[riskLevel].resourceLink"
            :box-link-label="riskLevels[riskLevel].resourceLinkLabel"
            :class="riskLevel" />
        </div>
      </template>
      <template #dashboard-footer>
        <div class="footer-text-container">
          <slot name="chart-explanation"></slot>
        </div>
      </template>
      <template #additional-info>Fonte: {{ reference }}</template>
    </dashboard-indicadores>
  </div>
</template>

<script>
import DashboardIndicadores from '@/components/DashboardIndicadores/DashboardIndicadores.vue';
import DashboardActionButton from '@/components/DashboardDadosColeta/DashboardActionButton.vue';
import FormDatasetsFilter from '@/components/DashboardDadosColeta/FormDatasetsFilter.vue';
import DashboardDatasetsChips from '@/components/DashboardDadosColeta/DashboardDatasetsChips.vue';
import LineChartDadosColeta from '@/components/DashboardDadosColeta/LineChartDadosColeta.vue';
import DashboardActionPlan from '@/components/DashboardDadosColeta/DashboardActionPlan.vue';

const RISK_LEVEL_COLORS = {
  good: '#0AB87F',
  average: '#F8950E',
  bad: '#D53C3C',
};

export default {
  name: 'dashboard-dados-coleta',
  components: {
    'dashboard-indicadores': DashboardIndicadores,
    'dashboard-action-button': DashboardActionButton,
    'form-datasets-filter': FormDatasetsFilter,
    'dashboard-datasets-chips': DashboardDatasetsChips,
    'line-chart-dados-coleta': LineChartDadosColeta,
    'dashboard-action-plan': DashboardActionPlan,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    datasetMunicipiosGeralEstado: {
      type: Array,
      required: true,
    },
    datasetMunicipiosEstado: {
      type: Array,
      required: true,
    },
    datasetCoordenadoriasGeralEstado: {
      type: Array,
      required: true,
    },
    datasetCoordenadoriasEstado: {
      type: Array,
      required: true,
    },
    riskLevels: {
      type: Object,
      required: true,
    },
    initialDatasetName: {
      type: String,
      default: '',
    },
    reference: {
      type: String,
      default: 'DataSUS',
    },
    scaleYText: {
      type: String,
      default: 'Cobertura (%)',
    },
    scaleXText: {
      type: String,
      default: 'Ano',
    },
  },
  data: (vm) => ({
    activeDatasetName: vm.initialDatasetName,
    activeDataset: [],
    activeDatasetGeral: [],
  }),
  computed: {
    isCoordenadoriasDatasetActive() {
      return this.activeDatasetName === 'coordenadorias';
    },
    isMunicipioDatasetActive() {
      return this.activeDatasetName === 'municipios';
    },
    getCoordenadoriasActiveDataset() {
      return this.isCoordenadoriasDatasetActive ? this.activeDataset : [];
    },
    getMunicipiosActiveDataset() {
      return this.isMunicipioDatasetActive ? this.activeDataset : [];
    },
    chartDatasets() {
      return [
        ...this.activeDatasetGeral,
        ...this.activeDataset,
      ];
    },
  },
  mounted() {
    this.activeDatasetName = this.initialDatasetName || 'coordenadorias';
    this.activeDatasetGeral = this.getDatasetByName(this.activeDatasetName, true);
  },
  methods: {
    getDatasetByName(name, isGeral) {
      if (name === 'coordenadorias') return isGeral ? this.datasetCoordenadoriasGeralEstado : this.datasetCoordenadoriasEstado;
      if (name === 'municipios') return isGeral ? this.datasetMunicipiosGeralEstado : this.datasetMunicipiosEstado;
      return [];
    },
    formConfirm(type, dataset, callback) {
      if (type === 'c') {
        this.activeDatasetName = 'coordenadorias';
        this.activeDatasetGeral = this.datasetCoordenadoriasGeralEstado;
      }

      if (type === 'm') {
        this.activeDatasetName = 'municipios';
        this.activeDatasetGeral = this.datasetMunicipiosGeralEstado;
      }

      this.activeDataset = dataset;
      callback();
    },
    removeDatasetItem(index) {
      this.activeDataset = this.activeDataset
        .filter((_, i) => i !== (index - 1)); // - 1 por activeDataset não ter o item para estado
    },
    riskColoringRule(value) {
      // eslint-disable-next-line
      const { good, average, bad, bad2 } = this.riskLevels;
      if (good?.riskRule(value)) return RISK_LEVEL_COLORS.good;
      if (average?.riskRule(value)) return RISK_LEVEL_COLORS.average;
      if (bad?.riskRule(value) || bad2?.riskRule(value)) return RISK_LEVEL_COLORS.bad;
      return '#000000';
    },
  },
};
</script>

<style lang="scss" scoped>
$color-risk-good: #0AB87F;
$color-risk-average: #F8950E;
$color-risk-bad: #D53C3C;

.action-plans {
  .good { --box-color: #{$color-risk-good}; }
  .average { --box-color: #{$color-risk-average}; }
  .bad, .bad2 { --box-color: #{$color-risk-bad}; }
  padding: 1.5rem;
  .action-plans__title { font-weight: 600; }
}

.form-datasets-filter__wrapper {
  width: 556px;
  max-width: 100%;
  background-color: #FFF;
  border: 1px solid #0A6458B2;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, .2);
  height: 92vh;
  overflow: scroll;
}

.dashboard-header__wrapper {
  padding: 1.5rem 0;
  overflow: hidden;
  .dashboard-header__buttons-wrapper {
    padding: 0 1.5rem;
    margin-bottom: 1rem;
  }
  .dashboard-header__chips-wrapper {
    display: flex;
    flex-wrap: nowrap;
    padding-left: 1.5rem;
    padding-bottom: 1.5rem;
    overflow-x: scroll;
    &::after {
      content: '';
      min-width: 1.5rem;
    }
  }
}

.chart-wrapper,
.footer-text-container { padding: 1.5rem; }

@include media-breakpoint-up(lg) {
  .action-plans {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1.5rem 2.25rem;
    .action-plans__title {
      width: 100%;
      font-size: 1.375rem;
    }
  }

  .dashboard-header__wrapper {
    padding: 1.5rem 2.25rem;
    overflow: visible;
    .dashboard-header__buttons-wrapper {
      padding: 0;
      margin-bottom: 2rem;
    }
    .dashboard-header__chips-wrapper {
      padding-left: 0;
      padding-bottom: 0;
      overflow-x: hidden;
      &::after { display: none; }
    }
  }

  .form-datasets-filter__wrapper {
    height: 438px;
    overflow: auto;
  }

  .chart-wrapper,
  .footer-text-container { padding: 1.5rem 2.25rem; }
}
</style>
